import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { auth } from './firebase'
import 'zingchart/es6'
import zingchartVue from 'zingchart-vue'
import InstantSearch from 'vue-instantsearch'

require('./assets/main.scss')

Vue.config.productionTip = false
Vue.component('zingchart', zingchartVue)
Vue.use(InstantSearch)

let app
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      data: {
        user: null,
      },
      render: h => h(App),
    }).$mount('#app')
  }
})
